import api from './apiService';
import { API_PATHS } from '../constants/portalApiPath';

const invoiceService = {
  getList: (data) => api.post(API_PATHS.INVOICE_LIST, data),
  getPaymentHistory: (data) => api.post(API_PATHS.INVOICE_PAYMENT_HISTORY, data),
  getOverdueInvoices: (data) => api.post(API_PATHS.INVOICES_OVERDUE, data),
};

export default invoiceService;
